import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { IApplicants, IDenyResidue, IDonateResidue } from 'src/app/interfaces';
import { ResiduesService } from 'src/app/services/residues.service';
import { UsersService } from 'src/app/services/users.service';
import * as M from '../../../../../styles/materialize/js/materialize.min.js';
@Component({
  selector: 'app-solicitantes-residuos',
  templateUrl: './solicitantes-residuos.component.html',
  styleUrls: ['./solicitantes-residuos.component.css']
})
export class SolicitantesResiduosComponent implements OnInit {
  constructor(private usersService: UsersService, private residuesService: ResiduesService, private snackBar: MatSnackBar) { }

  options = {};
  applicants: IApplicants[] = [];
  imageUrl: string = "";

  ngOnInit(): void {
    const elements = document.querySelectorAll('.sidenav');
    M.Sidenav.init(elements, this.options);

    this.residuesService.getAppliedResidues().subscribe((applicants) => {
      applicants.map(applicant => {
          this.residuesService.getResidueImage(applicant.residue.imagePath).subscribe((image: any) =>  {
            applicant.residue.imagePath = `url(${image.signedURL})`;
          })

          this.applicants = applicants;
      })
    })
  }

  removeApplicant(currentApplicant: IApplicants) {
    this.applicants = this.applicants.filter(applicant => applicant.id !== currentApplicant.id)
  }

  acceptApplication(applicant: IApplicants) {
    const { id } = applicant;
    
    const payload: IDonateResidue = {
      id: id,
    }

    this.residuesService.donateResidue(payload).subscribe(
      () => {
        this.snackBar.open("A solicitação do resíduo foi aceita com sucesso", "Fechar", {
          duration: 7000,
        });
        this.removeApplicant(applicant);
      },
      () => {
        this.snackBar.open("Não foi possível aceitar a solicitação do resíduo, por favor tente mais tarde", "Fechar", {
          duration: 7000,
        })
      }
    )
  }

  denyApplication(applicant: IApplicants) {
    const { id } = applicant;
    
    const payload: IDenyResidue = {
      id: id,
    }

    this.residuesService.denyResidue(payload).subscribe(
      () => {
        this.snackBar.open("A solicitação do resíduo foi cancelada com sucesso", "Fechar", {
          duration: 7000,
        });
        this.removeApplicant(applicant);
      },
      () => {
        this.snackBar.open("Não foi possível cancelar a solicitação do resíduo, por favor tente mais tarde", "Fechar", {
          duration: 7000,
        })
      }
    )
  }

  logout(){
    this.usersService.logout();
  }
}
